import { useEffect, useState } from "react";
import useAxios from "../hooks/useAxios";
import CurrencyFormat from "react-currency-format";
import clsx from "clsx";
import { Spinner } from "react-bootstrap";
import { AiFillExclamationCircle } from "react-icons/ai";

const UpdatePlanStaff = ({
    planStaffId,
    defaultValue,
    name,
    canUpdate
}) => {
    const [hasError, setHasError] = useState(false);
    const [currentValue, setCurrentValue] = useState('');

    const [{ loading: loadingUpdatePlanStaff }, updatePlanStaff] = useAxios(
        { url: `/plan-staff/${planStaffId}/${name}`, method: 'PUT' },
        { useCache: false, manual: true }
    );

    useEffect(() => {
        if (defaultValue !== undefined && defaultValue !== null) setCurrentValue(defaultValue);
    }, [defaultValue]);

    const handleChange = (e) => {
        if (canUpdate) {
            setHasError(false);
            try {
                setCurrentValue(e.target.value);
                updatePlanStaff({
                    data: {
                        value: Number(e.target.value)
                    }
                });
            } catch (error) {
                setHasError(true);
            }
        }
    };

    return (
        <div className="pm-cell-container position-relative">
            <CurrencyFormat
                className={clsx(["form-control pm-numeric-input"], {
                    'val-error': hasError,
                    'val-positive': !hasError && Number(currentValue) > 0,
                    'val-negative': !hasError && Number(currentValue) < 0,
                })}
                value={currentValue}
                decimalSeparator=","
                thousandSeparator="."
                isNumericString
                readOnly={!planStaffId || !canUpdate}
                title={!canUpdate ? 'No tienes permisos para modificar este valor' : ''}
                onValueChange={(e) => handleChange({ target: { name: 'amount', value: e.value } })}
                placeholder="0"
            />

            {loadingUpdatePlanStaff && (
                <div className="position-absolute end-0 me-1" style={{ top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                    <Spinner variant="primary" style={{ width: 14, height: 14 }} animation="border" />
                </div>
            )}

            {!loadingUpdatePlanStaff && hasError && (
                <div className="position-absolute end-0 me-1" style={{ top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                    <AiFillExclamationCircle className="text-danger" style={{ fontSize: 13 }} />
                </div>
            )}
        </div>
    );
};

export default UpdatePlanStaff;